import { AxiosResponse } from 'axios';
import api from '~/services/api';

class JustificationsService {
  getAll({ skip = 0, limit = 10, ...filters }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/preset-justification', {
      params: {
        skip,
        limit,
        ...filters
      },
      ...opts
    });
  }

  getAllCount(opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/preset-justification/count', {
      ...opts
    });
  }

  getJustification(id: string): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/vendor-client-visit/preset-justification?internalCode=${id}`);
  }

  deleteJustification(id: string): Promise<AxiosResponse<any[] | null>> {
    return api.delete(`/vendor-client-visit/preset-justification/${id}`);
  }

  createJustification(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/vendor-client-visit/preset-justification', payload);
  }

  editJustification({ id, payload }: { id: string; payload: any }): Promise<AxiosResponse<any | null>> {
    return api.put(`/vendor-client-visit/preset-justification/${id}`, payload);
  }
}

export default new JustificationsService();
